import anime from 'animejs';

import { generateClampedRandom } from './components/Generator/Cat/utils';
import { catEmojis } from './constants';

/**
 * Some defaults for the explosion
 */
const transformBounds = { min: 30, max: 150 };
const explosionCount = 10;
const emojiPixelSize = 32;

/**
 * Generate a random transform value
 */
export const transformGenerator = () => {
  const reverse = Math.round(Math.random());
  const transformAmount = generateClampedRandom({ ...transformBounds });
  return reverse ? -transformAmount : transformAmount;
}

/**
 * Cat explosion on click
 */
export const catExplosion = (event) => {
  const { pageX, pageY } = event;

  const elements = [...Array(explosionCount)].map((item) => {
    const el = document.createElement('div');
    el.className = 'cat-emoji';
    el.style.left = `${pageX - (emojiPixelSize / 2)}px`;
    el.style.top = `${pageY - (emojiPixelSize / 2)}px`;
    el.innerText = catEmojis[Math.floor(Math.random() * catEmojis.length)];
    document.body.appendChild(el);
    return el;
  });

  anime({
    targets: [...elements],
    duration: 600,
    easing: 'easeOutExpo',
    translateX: () => transformGenerator(),
    translateY: () => transformGenerator(),
    rotate: () => {
      const angle = Math.random() * 360;
      return Math.floor(Math.random()) ? angle : -angle;
    },
    opacity: {
      value: [0, 1],
      duration: 300,
    },
    scale: {
      value: 0,
      delay: 350,
    },
    complete: () => {
      elements.forEach((el) => {
        document.body.removeChild(el);
      })
    }
  });
};